import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SeUiControlsModule } from '@se/se.ui.html5';

// TODO: Trovare un posto per il modulo Shared al di fuori di platform.
import { SeSharedModule } from '../../../se-modules-platform/src/lib/shared.module';

import { AddExamComponent } from './add-exam/add-exam.component';
import { MergeExamComponent } from './merge-exam/merge-exam.component';
import { ObscuredDataComponent } from './obscured-data/obscured-data.component';
import { PatientCertificationComponent } from './patient-certification/patient-certification.component';
import { RemoveExamComponent } from './remove-exam/remove-exam.component';
import { LineGraphComponent } from './line-graph/line-graph.component';
import { ImportGridComponent } from './import-grid/import-grid.component';
import { SuspendExamComponent } from "./suspend-exam/suspend-exam.component";
import { SePlatformModule } from '@se/platform';

@NgModule({
    imports: [SeSharedModule, SeUiControlsModule, TranslateModule, SePlatformModule],
    declarations: [
        AddExamComponent,
        ImportGridComponent,
        LineGraphComponent,
        MergeExamComponent,
        ObscuredDataComponent,
        PatientCertificationComponent,
        RemoveExamComponent,
        SuspendExamComponent
    ],
    exports: [
        AddExamComponent,
        LineGraphComponent,
        MergeExamComponent,
        ObscuredDataComponent,
        PatientCertificationComponent,
        RemoveExamComponent,
        SuspendExamComponent
    ],
})
export class SeComponentsModule {}
